import React from 'react';
import { format } from 'date-fns';
import { PredictPatient } from '~/types/predict';
import EhrStatusRow from './EhrStatusRow';

/**
 * Transfer stage content — a read-only status indicator (NOT an actionable
 * control). Reflects whether the transfer order has been entered in the source
 * system (the EHR); it checks off automatically once we're notified.
 */
const TransferStageContent: React.FC<{ patient: PredictPatient }> = ({ patient }) => {
  const order = patient.transferOrder;
  const entered = !!order?.entered;

  const detail = (
    <>
      {order?.physician && <>Ordered by <strong>{order.physician}</strong></>}
      {order?.physician && order?.enteredAt && ' · '}
      {order?.enteredAt && format(new Date(order.enteredAt), "MMM d, yyyy 'at' h:mm a")}
    </>
  );

  return <EhrStatusRow done={entered} title="Transfer order" detail={detail} />;
};

export default TransferStageContent;
